// this is for a new Form
// this is for a form in progress
// drawmode indicate if horizontal drawing
export const horizontal = 'horizontal'; // todo in common utils
// FORMS control types

export const label = 'label';
export const input = 'input';
export const date = 'date';
export const signature = 'signature';
export const radio = 'radio';
export const singleselect = 'singleselect';
export const multiselect = 'multiselect';
export const checkbox = 'checkbox';
export const statement = 'statement';
export const map = 'map'; // FORMS css

export const bullet = 'bullet';
export const isonerequired = 'isonerequired';